<header class="header" #header [class.hidden]="scroll.navbarHidden()">
  <a *ngIf="isHomePage" href="/" class="logo"  #logo>Marc Wieland &lt;/Software &amp; Consulting&gt;.</a>
  <!-- [ngClass]="isDarkMode ? 'darkMode-dark' : 'darkMode-light'" -->
  <nav class="navbar">
    <img src="flags/de.png" alt="Deutsch" (click)="switchLang('de')">
    <img src="flags/ch.png" alt="Schweizerdeutsch" (click)="switchLang('de-CH')">
    <img src="flags/gb.png" alt="English" (click)="switchLang('en')">
  </nav>

  <div class="toggle-theme" (click)="toggleTheme()"  >
    <i class="bx" [ngClass]="isDarkMode ? 'bx-sun' : 'bx-moon'" #toggleIcon></i>
  </div>
</header>
